/* src/app/stocking/menus/menus.component.css */
.tab {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.tab-current {
  color: var(--mat-minimal-pseudo-checkbox-selected-checkmark-color);
}
.tab-before {
  color: Gray;
}
.tab-locked {
  color: rgb(156, 0, 0);
}
/*# sourceMappingURL=menus.component.css.map */
